import uiTheme from "./ui.json";
import { DEV_LST_BACKEND_PROXY_PATH } from "./devProxyPrefix";
import { THEME_PRESETS, THEME_STORAGE_KEY, DEFAULT_THEME_ID, getPresetById, getStoredThemeId } from "./themePresets";
export const APP_VERSION = import.meta.env.VITE_APP_VERSION ?? "1.0.0";
export const UI_THEME = uiTheme;
export { THEME_PRESETS, THEME_STORAGE_KEY, DEFAULT_THEME_ID, getStoredThemeId };
export function applyUiTheme() {
    const root = document.documentElement;
    const base = uiTheme?.cssVars;
    if (base && typeof base === "object") {
        Object.entries(base).forEach(([k, v]) => {
            if (typeof v === "string")
                root.style.setProperty(k, v);
        });
    }
    const id = getStoredThemeId();
    const preset = getPresetById(id);
    const extra = preset?.cssVars;
    if (extra && typeof extra === "object") {
        Object.entries(extra).forEach(([k, v]) => {
            if (typeof v === "string")
                root.style.setProperty(k, v);
        });
    }
}
export function setUiThemePreset(themeId) {
    const preset = getPresetById(themeId);
    try {
        localStorage.setItem(THEME_STORAGE_KEY, preset.id);
    }
    catch (e) {
    }
    applyUiTheme();
}
/** 默认 LST 网关；多平台切换时实际域名由 utils/apiPlatform 决定 */
export const LST_API_BASE = import.meta.env.VITE_LST_API_BASE ?? "http://127.0.0.1:8080";
export const CDN_IMG_BASE = import.meta.env.VITE_CDN_IMG_BASE ?? "https://yst-file.zjcaee.com";
/**
 * 本地 `npm run dev` 调试：为 true 时请求走 `DEV_LST_BACKEND_PROXY_PATH`，由 Vite 代理到自研 Spring（默认 8080）。
 * 为 false 时「服务类」基址与 Spring 一致：使用 `LST_API_BASE`（默认同 `VITE_LST_API_BASE`，如本机 8080），不再硬编码 3900。
 * 生产：未设置 `VITE_SERVICE_BASE_URL` 时与 `VITE_LST_API_BASE` 同机，不再默认第三方域名。
 */
export const isLocalDebug = false;

function resolveServiceBaseUrl() {
    const fromEnv = import.meta.env.VITE_SERVICE_BASE_URL;
    if (fromEnv)
        return String(fromEnv).replace(/\/$/, "");
    if (import.meta.env.DEV) {
        if (isLocalDebug)
            return DEV_LST_BACKEND_PROXY_PATH;
        return String(LST_API_BASE || "").replace(/\/$/, "") || "http://127.0.0.1:8080";
    }
    return String(LST_API_BASE || "").replace(/\/$/, "") || "http://127.0.0.1:8080";
}
export const SERVICE_BASE_URL = resolveServiceBaseUrl();
